import { render, staticRenderFns } from "./MyDatamatrix.vue?vue&type=template&id=692edbea&scoped=true"
import script from "./MyDatamatrix.vue?vue&type=script&lang=js"
export * from "./MyDatamatrix.vue?vue&type=script&lang=js"
import style0 from "./MyDatamatrix.vue?vue&type=style&index=0&id=692edbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692edbea",
  null
  
)

export default component.exports